ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_review_card'] = require '../../review_card.html.mustache'

ProductReviews.Views.ReviewCard = Backbone.View.extend
  events:
    'click .read-more': 'toggleReadMore'

  initialize: ->
    if @model.displayOptions?.readMoreEnabled
      @listenTo @model, 'change:reviewTextHeight', @updateReadMore

  render: ->
    data = _.extend {}, @model.attributes,
      displayOptions: @model.displayOptions
      translate: -> (text) -> I18n.t "js.#{text}"

    @$el.append ProductReviews.Templates['product_reviews_review_card'].render(data)
    @$readMore = @$el.find('.read-more')
    @$reviewText = @$el.find('.review-text-container')

  updateReadMore: ->
    @$reviewText.toggleClass('show', @model.shouldShowReadMore())

  toggleReadMore: ->
    if @$reviewText.hasClass('expanded')
      @$reviewText.removeClass('expanded')
      @$readMore.text I18n.t('js.modules.product_reviews.review_card.read_more')
    else
      @$reviewText.addClass('expanded')
      @$readMore.text I18n.t('js.modules.product_reviews.review_card.read_less')

module.exports = ProductReviews.Views.ReviewCard
